import React from "react";

const viewportContext = React.createContext({});





export const BreakPointScreen = (width) => {
    const xs = 576 //<576px
    const sm = 768 //≥576px a <768
    const md = 992 //≥768px a <992
    const lg = 1200 //≥992px a <1200
    const xl = 1400 //≥1200px a <1400
    //const xxl ≥1400px 
    switch (true) {
        case (width < xs):
            return 'xs'
        case (width < sm):
            return 'sm'
        case (width < md):
            return 'md'
        case (width < lg):
            return 'lg'
        case (width < xl):
            return 'xl'
        default:
            return 'xxl'
    }

};



export const ViewportProvider = ({ children }) => {
    const [breakPoint, setBreakPoint] = React.useState(BreakPointScreen(window.innerWidth));
    const handleWindowResize = () => {
        setBreakPoint(BreakPointScreen(window.innerWidth));

    }
    React.useEffect(() => {
        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    return (
        <viewportContext.Provider value={{ breakPoint }}>
            {children}
        </viewportContext.Provider>
    );
};


export const useViewport = () => {
    /* We can use the "useContext" Hook to acccess a context from within another Hook */
    const { breakPoint } = React.useContext(viewportContext);
    return { breakPoint };
}


export default useViewport